import * as React from "react";
import TryAgainToolTip from '../common/TryAgainToolTip';

export default class AppointmentMenuHead extends React.Component {
    componentDidMount() {
    }

    render() {
        const { disabled, disabledIndex, isMobile, appt } = this.props;
        //let status = appt.status;
        //switch (status) {
        //    case 'ROOM_EMPTY': status = 'Room Empty'; break;
        //    case 'PATIENT_IN_ROOM': status = 'Patient in Room'; break;
        //    case 'ROOMING_IN_PROGRESS': status = 'Rooming in Progress'; break;
        //    case 'READY_FOR_PROVIDER': status = 'Ready for Provider'; break;
        //    case 'IN_PROGRESS': status = 'In Progress'; break;
        //}

        return (
            <React.Fragment>
                {disabled && !isMobile &&
                    <React.Fragment>
                        <div
                            className="appt-head-disabled-tooltip"
                            id={disabledIndex}
                        />
                        <TryAgainToolTip
                            target={disabledIndex}
                            className="try-again-main-menu-tooltip"
                        />
                    </React.Fragment>
                }
                <div className="appt-head">
                    <div className="appt-head__info">
                        <div className="appt-names truncate">{appt.patientName}</div>
                        <div className="appt-status">{appt.statusUpdated/*status*/}</div>
                    </div>
                    <div className="appt-head__time">{appt.apptTime} <span className="icon-dd" /> <span className="icon-dd-up" /></div>
                </div>
            </React.Fragment>
        );
    }
}

